import ArrowUpRight from '@components/Icons/arrow-up-right.svg';

const ExternalLink = ({ data }) => {
	const { external_link: link = {} } = data;

	const linkTarget = '_blank';
	const hasLink = link?.url && link?.label;

	return (
		hasLink && (
			<a
				className="cfs-talk-external-link"
				href={link.url}
				target={link.new_tab ? linkTarget : '_self'}
			>
				{link.label}
				<img
					className="cfs-talk-external-link-ui-icon"
					src={ArrowUpRight}
					alt="Arrow up right icon"
					width="16"
					height="16"
				/>
			</a>
		)
	);
};
export default ExternalLink;
